/**
 * LiveFeed.js — "Latest Scan" card — shows name if registered, UID otherwise
 */

import React from "react";

export default function LiveFeed({ latest, lookup }) {
  if (!latest) {
    return (
      <div className="glass-card px-6 py-5 flex items-center gap-4 animate-fade-in">
        <div className="w-10 h-10 rounded-xl bg-slate-100 flex items-center
                        justify-center text-slate-400 text-lg flex-shrink-0">
          📡
        </div>
        <div>
          <p className="text-sm font-semibold text-slate-500">Awaiting first scan...</p>
          <p className="text-xs text-slate-400 mt-0.5">Point an RFID card to the reader</p>
        </div>
      </div>
    );
  }

  const isPresent = latest.status === "present";
  const person    = lookup ? lookup(latest.uid) : null;

  return (
    <div
      key={latest.id}
      className={`glass-card px-6 py-5 flex items-center gap-4 animate-slide-in
                  border-l-4 ${isPresent ? "border-l-emerald-400" : "border-l-red-400"}`}
    >
      {/* Avatar / icon */}
      {person ? (
        <div className="w-11 h-11 rounded-xl bg-brand-100 flex items-center
                        justify-center text-brand-700 text-lg font-bold flex-shrink-0">
          {person.name.charAt(0).toUpperCase()}
        </div>
      ) : (
        <div className={`w-11 h-11 rounded-xl flex items-center justify-center
                         text-xl flex-shrink-0 ${isPresent ? "bg-emerald-50" : "bg-red-50"}`}>
          {isPresent ? "✅" : "🚫"}
        </div>
      )}

      {/* Info */}
      <div className="flex-1 min-w-0">
        {person ? (
          <>
            <div className="flex items-center gap-2 flex-wrap">
              <span className="font-bold text-slate-800 text-sm">{person.name}</span>
              <span className="text-xs text-slate-400 font-medium">{person.studentId}</span>
              <span className={`text-xs font-semibold px-2 py-0.5 rounded-full ${
                isPresent ? "bg-emerald-100 text-emerald-700" : "bg-red-100 text-red-700"
              }`}>
                {isPresent ? "Attendance Marked" : "Access Denied"}
              </span>
            </div>
            <p className="text-xs text-slate-400 mt-0.5">
              <span className="font-mono">{latest.uid}</span> · {latest.timestamp}
            </p>
          </>
        ) : (
          <>
            <div className="flex items-center gap-2 flex-wrap">
              <span className="font-mono font-bold text-slate-800 text-sm tracking-wider">
                {latest.uid}
              </span>
              <span className={`text-xs font-semibold px-2 py-0.5 rounded-full ${
                isPresent ? "bg-emerald-100 text-emerald-700" : "bg-red-100 text-red-700"
              }`}>
                {isPresent ? "Attendance Marked" : "Access Denied"}
              </span>
            </div>
            <p className="text-xs text-slate-400 mt-0.5">{latest.timestamp}</p>
          </>
        )}
      </div>

      {/* Live pulse */}
      <div className="flex items-center gap-1.5 text-xs font-semibold text-brand-500 flex-shrink-0">
        <span className="w-1.5 h-1.5 rounded-full bg-brand-500 animate-pulse2" />
        LIVE
      </div>
    </div>
  );
}
